import { AnswerSheet } from "models/controller";
import { atom } from "recoil";

export const answerSheetState = atom<AnswerSheet>({
  key: "answerSheet",
  default: {},
});
